import React from 'react'
import CV from '../../assets/migueldisulord-englishcv.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href={CV} download className='buttonToInteractWithMe'>Download CV</a>
        <a href='#contact' className='buttonToInteractWithMe buttonToInteractWithMe-primary'>Let's talk!</a>

    </div>
  )
}

export default CTA